function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("rect", {
  width: 40,
  height: 40,
  rx: 20,
  fill: "url(#email_svg__paint0_linear_427_109505)"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M10 13.5a2.5 2.5 0 012.5-2.5h15a2.5 2.5 0 012.5 2.5v13a2.5 2.5 0 01-2.5 2.5h-15a2.5 2.5 0 01-2.5-2.5v-13zm2.5-.5a.5.5 0 00-.5.5v2.764l8 3.638 8-3.636V13.5a.5.5 0 00-.5-.5h-15zM28 18.463l-8 3.636-8-3.638V26.5a.5.5 0 00.5.5h15a.5.5 0 00.5-.5v-8.037z",
  fill: "#fff"
});

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "email_svg__paint0_linear_427_109505",
  x1: 0.813,
  y1: 0,
  x2: 35.231,
  y2: 43.09,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#5B576A"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#15131C"
})));

function SvgEmail(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref, _ref2, _ref3);
}

export default SvgEmail;